/* src/app/modules/shared/components/header-column/header-column-cannabinoid/header-column-cannabinoid.component.scss */
app-header-column-cannabinoid {
  display: contents;
}
/*# sourceMappingURL=header-column-cannabinoid.component.css.map */
